module.exports = __webpack_public_path__ + "img/ico-notif-fan.be182384.svg";